export const GeneralConditionPage = () => {
  return (
    <>
      <div className="w-full flex flex-col  px-1">
        <div className="text-lg 2xl:text-xl font-bold text-[#19295C]  text-center mb-4 gap-1">
          Conditions générales de vente et d'utilisation de l’application web
          HelpClic
        </div>
        <div className="card">
          <div className="card-header">
            <h4 className="card-title !text-base">
              Annulation, report et remboursement
            </h4>
          </div>
          <div className="card-body !text-sm">
            <p>
              Lorsqu’un Client annule une intervention, le remboursement dépend
              du délai restant avant le rendez-vous : 100 % au moins 6 heures
              avant, 70 % entre 4 heures et moins de 6 heures, 50 % entre
              2 heures et moins de 4 heures, et aucun remboursement moins de
              2 heures avant le rendez-vous.
            </p>
            <p>
              Une annulation par le Prestataire donne lieu à un remboursement
              intégral. Le remboursement est également intégral si le
              Prestataire demande un report et que le Client refuse la nouvelle
              date proposée.
            </p>
            <p>
              Lorsqu’un remboursement est annoncé à 100 %, le montant reversé
              au Client correspond au montant effectivement encaissé par
              HelpClic, après déduction des frais de traitement Stripe liés au
              paiement initial. Ces frais techniques, prélevés par Stripe, ne
              sont pas remboursables par HelpClic.
            </p>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <h4 className="card-title !text-base">
              Règles de la messagerie
            </h4>
          </div>
          <div className="card-body !text-sm">
            <p>
              Afin de protéger les utilisateurs et les paiements réalisés sur
              la plateforme, il est interdit de transmettre une adresse e-mail
              ou un numéro de téléphone dans les messages, dans un nom de
              fichier ou sous une forme volontairement dissimulée.
            </p>
            <p>
              Tout contenu de ce type est immédiatement refusé et supprimé
              avant sa publication. Une première tentative entraîne un
              avertissement. En cas de récidive, le compte est bloqué et les
              sessions actives sont fermées. L’utilisateur peut contacter
              support@help-clic.fr pour toute contestation.
            </p>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <h4 className="card-title !text-base capitalize-first">
              {" "}
              À quoi sert l’application web HelpClic ?
            </h4>
          </div>
          <div className="card-body !text-sm">
            <p>
              L’application web HelpClic «help-clic.fr » a été conçue pour
              mettre en relation des Clients avec des professionnels qui
              interviennent à domicile pour réaliser tous types de Prestations.
            </p>
            <p>
              HelpClic agit uniquement en tant qu’intermédiaire médiateur entre
              les Clients et les prestataires de services. Il ne fournit aucune
              Prestation et ne fait pas partie du contrat qui lie les deux
              parties prenantes.
            </p>
            <p>
              Les prestataires sont sélectionnés et vérifiés par HelpClic. Ces
              derniers s'engagent à respecter la Charte de Qualité qui définit
              les compétences, le métier et le niveau de compétences attendu
              pour garantir des Prestations en bonne et due forme.
            </p>
            <p>
              De son côté, HelpClic s’engage à faciliter la mise en relation,
              sans être responsable des engagements contractuels nouant le
              Client et le prestataire.
            </p>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <h4 className="card-title !text-base capitalize-first">
              {" "}
              Acceptation
            </h4>
          </div>
          <div className="card-body !text-sm">
            <p>
              Au moment de la création de votre compte via l’application web
              HelpClic, qu’il s’agisse d’un prestataire ou d’un client à la
              recherche d’un service bien précis, l’acceptation des conditions
              générales de l’application est définitive, jusqu’à désinscription,
              suspension provisoire ou fermeture définitive de votre compte.
            </p>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <h4 className="card-title !text-base"> Engagements </h4>
          </div>
          <div className="card-body !text-sm">
            <p>
              HelpClic Les clients comme les prestataires aux profils douteux et
              aux agissements contraires à l'éthique et à la politique de
              HelpClic, peuvent être bannis à jamais.
            </p>
            <p>
              HelpClic se réserve le droit de recenser et d’afficher les
              notations, effectuées par les clients, pour évaluer le prestataire
              de services et son intervention selon plusieurs critères. Les
              services de modération de l’application web HelpClic se réservent
              le droit de refuser la transmission de la demande d’intervention
              au réseau des prestataires de services si celle-ci est jugée
              irréalisable ou injustifiée après examen.
            </p>
            <p>
              Un suivi post-intervention est systématiquement effectué, en plus
              de la modération et de la vérification continue des profils
              utilisateurs ; HelpClic est exclu de toute obligation de résultat.
            </p>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <h4 className="card-title !text-base capitalize-first">
              {" "}
              Inscription et réservation d’intervention
            </h4>
          </div>
          <div className="card-body !text-sm">
            <ol className="list-decimal flex flex-col gap-3 pl-2 ">
              <li className="font-medium">
                Accédez à l’application web HelpClic « help-clic.fr »
              </li>
              <li className="font-medium">
                Inscrivez-vous et créez votre compte utilisateur.
              </li>
              <li className="font-medium">
                Recherchez et réservez des interventions de prestataires dans de
                nombreuses activités disponibles sur notre plateforme :
                <ul className="list-disc pl-5 mt-2  space-y-2">
                  <li>
                    <span className="font-semibold">Option 1 :</span> Déposez
                    une annonce en tant que Client, puis sélectionnez l'offre du
                    prestataire correspondant à vos besoins.
                  </li>
                  <li>
                    <span className="font-semibold">Option 2 :</span> Utilisez
                    la barre de recherche pour trouver directement le
                    prestataire dont vous avez besoin.
                  </li>
                </ul>
              </li>
              <li className="font-medium">
                Sélection du professionnel : Une fois le prestataire choisi,
                vous pourrez entamer une négociation concernant :
                <ul className="list-disc pl-5 mt-2  space-y-1">
                  <li>La nature du problème.</li>
                  <li>Les tarifs appliqués.</li>
                  <li>Tous les détails nécessaires pour l’intervention.</li>
                </ul>
              </li>
              <li className="font-medium">
                Validation et paiement : Après accord entre les parties,
                effectuez le paiement pour :
                <ul className="list-disc pl-5 mt-2  space-y-1">
                  <li>Confirmer l’intervention.</li>
                  <li>Fixer le jour et les horaires convenus.</li>
                </ul>
              </li>
              <li className="font-medium">
                Garantie de satisfaction :
                <ul className="list-disc pl-5 mt-2  space-y-1">
                  <li>
                    Sous 14 jours, si vous n’êtes pas satisfait, vous serez
                    remboursé intégralement.
                  </li>
                  <li>
                    Si tout s’est déroulé comme prévu, le paiement sera
                    transféré au prestataire.
                  </li>
                </ul>
              </li>
              <li className="font-medium">
                Paiement du prestataire : Le professionnel reçoit son paiement
                au bout de 14 jours, une fois la prestation validée par le
                Client.
              </li>
            </ol>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <h4 className="card-title !text-base capitalize-first">
              {" "}
              Politique de confidentialité et réglementation qui régissent
              l’application web HelpClic
            </h4>
          </div>
          <div className="card-body !text-sm">
            <p>
              HelpClic s’engage fermement et indéfiniment à protéger la
              confidentialité de toutes les données des utilisateurs, qu’il
              s’agisse des clients ou des prestataires. Cette politique garantit
              une gestion sécurisée et respectueuse des informations,
              conformément aux normes en vigueur.
            </p>
            <p>
              La validité des présentes Conditions Générales de vente et
              d'utilisation de l’application web HelpClic, en fond comme en
              forme, est entièrement soumise à la Loi et la réglementation
              française en vigueur, et ce, quelle que soit la nationalité de
              l'intervenant.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralConditionPage;
